/** Replace one order's complete shipment snapshot without clearing other orders. */
export function replaceShipmentSnapshot<T extends { id?: number }>(
    cached: readonly T[], previousIds: readonly number[], incoming: readonly T[]
): T[] {
    const removed = new Set(previousIds);
    const byId = new Map(cached.filter(shipment => !removed.has(shipment.id))
        .map(shipment => [shipment.id, shipment]));
    for (const shipment of incoming) byId.set(shipment.id, shipment);
    return Array.from(byId.values());
}
